import React from 'react';
import * as S from '../SortBy/SortBy.styles';
import Icon from '../../../../../stories/core-components/IconsSelector';
const SortBy = props => {
  const sortBy = props.type;
  const bestClass = isActive('best', sortBy);
  const ratingClass = isActive('rating', sortBy);
  const departureClass = isActive('departure', sortBy);
  const arrivalClass = isActive('arrival', sortBy);
  const speedClass = isActive('speed', sortBy);
  const priceClass = isActive('price', sortBy);

  return (
    <S.SortingWrapDiv>
      <S.LeftWrapDiv>
        {props.busCount ? (
          <>
            <S.ShowingTextSpan>Showing</S.ShowingTextSpan>

            <S.BusTextSpan>
              {props.busCount} bus{props.busCount > 1 ? 'es' : ''}
            </S.BusTextSpan>
          </>
        ) : null}
      </S.LeftWrapDiv>
      <S.SortByDiv>
      {/* <S.SortbyDividerDiv> */}
        <S.SortBytxtSpan>Sort by:</S.SortBytxtSpan>
      {/* </S.SortbyDividerDiv> */}
      <S.SortingFiltersDiv onClick={props.onClick}>
        <S.FilterstxtSpan className={bestClass} data-testid="sortingOption" data-val="best">
          BEST&nbsp;
          {sortBy === 'best' ? <Icon name='ArrowDownIcon' styleProps={{width: '1rem', height: '1rem', fill: '#2276e3'}} /> : null}
        </S.FilterstxtSpan>
        <S.FilterstxtSpan
          className={ratingClass}
          data-val={sortBy === 'rating_high' ? 'rating_low':'rating_high'}
        >
          RATING&nbsp;
          {sortBy === 'rating_low' ? <Icon name='ArrowDownIcon' styleProps={{width: '1rem', height: '1rem', fill: '#2276e3'}} /> : null}
          {sortBy === 'rating_high' ? <Icon name='ArrowUpIcon' styleProps={{width: '1rem', height: '1rem', fill: '#2276e3'}} /> : null}
        </S.FilterstxtSpan>
        <S.FilterstxtSpan
          className={departureClass}
          data-val={sortBy === 'late_departure' ? 'early_departure':'late_departure'}
        >
          DEPARTURE&nbsp;
          {sortBy === 'early_departure' ? <Icon name='ArrowDownIcon' styleProps={{width: '1rem', height: '1rem', fill: '#2276e3'}} /> : null}
          {sortBy === 'late_departure' ? <Icon name='ArrowUpIcon' styleProps={{width: '1rem', height: '1rem', fill: '#2276e3'}} /> : null}
        </S.FilterstxtSpan>
        <S.FilterstxtSpan
          className={arrivalClass}
          data-val={sortBy === 'late_arrival' ? 'early_arrival' :'late_arrival' }
        >
          ARRIVAL&nbsp;
          {sortBy === 'early_arrival' ? <Icon name='ArrowDownIcon' styleProps={{width: '1rem', height: '1rem', fill: '#2276e3'}} /> : null}
          {sortBy === 'late_arrival' ? <Icon name='ArrowUpIcon' styleProps={{width: '1rem', height: '1rem', fill: '#2276e3'}} /> : null}
        </S.FilterstxtSpan>
        <S.FilterstxtSpan
          className={speedClass}
          data-val={sortBy === 'high_speed' ? 'low_speed':'high_speed'}
        >
          FASTEST&nbsp;
          {sortBy === 'low_speed' ? <Icon name='ArrowDownIcon' styleProps={{width: '1rem', height: '1rem', fill: '#2276e3'}} /> : null}
          {sortBy === 'high_speed' ? <Icon name='ArrowUpIcon' styleProps={{width: '1rem', height: '1rem', fill: '#2276e3'}} /> : null}
        </S.FilterstxtSpan>
        <S.FilterstxtSpan
          className={priceClass}
          data-val={sortBy === 'high_price' ? 'low_price' : 'high_price'}
        >
          CHEAPEST&nbsp;
          {sortBy === 'low_price' ? <Icon name='ArrowDownIcon' styleProps={{width: '1rem', height: '1rem', fill: '#2276e3'}} /> : null}
          {sortBy === 'high_price' ? <Icon name='ArrowUpIcon' styleProps={{width: '1rem', height: '1rem', fill: '#2276e3'}} /> : null}
        </S.FilterstxtSpan>
      </S.SortingFiltersDiv>
      </S.SortByDiv>
    </S.SortingWrapDiv>
  );
};

export default SortBy;

function isActive(type: string, sortBy: string) {
  return sortBy.indexOf(type) !== -1 ? 'active' : '';
}
